import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Card, Grid, styled, Typography } from '@mui/material';
import axios from 'axios';
import { compareAsc, parseISO } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import SchoolApproved from '../components/Actions/SchoolApproved';
import SchoolRating from '../components/Actions/SchoolRating';
import BookingHeader from '../components/BookingInfo/BookingHeader';
import BookingRating from '../components/BookingInfo/BookingRating';
import BookingSubDetails from '../components/BookingInfo/BookingSubDetails';
import Documents from '../components/BookingInfo/Documents';
import NoBookingFound from '../components/BookingInfo/NoBookingFound';
import Qualifications from '../components/BookingInfo/Qualifications';
import SchoolInfoProvided from '../components/BookingInfo/SchoolInfoProvided';
import TeacherFeedback from '../components/BookingInfo/TeacherFeedback';
import Loading from '../components/Loading';
import Title from '../components/Navbar/Title';
import SimpleSnackbar from '../components/SnackBar/SimpleSnackbar';
import sendNotification from '../utils/sendNotification';
import { cancelBooking, fetchSchoolBooking } from '../redux/BookingSlice';
import { fetchSchool } from '../redux/SchoolSlice';

const RootGrid = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
}));

const SelectEmptyGrid = styled(Grid)(({ theme }) => ({
    margin: theme.spacing(3),
}));

const TeacherCard = styled('div')(({ theme }) => ({
    margin: '20px',
}));

const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

export const ViewSchoolBooking = props => {
    // const classes = useStyles();
    let match = useRouteMatch('/:basePath/school-booking/:bookingId');
    //const id = 0;

    const { getAccessTokenSilently } = useAuth0();

    const { booking } = useSelector(state => state.booking);
    const bookingStatus = useSelector(state => state.booking.status);
    const profileStatus = useSelector(state => state.profile.status);
    const profile = useSelector(state => state.profile);
    const schoolStatus = useSelector(state => state.school.status);
    const schoolInfo = useSelector(state => state.school);

    const dispatch = useDispatch();

    let history = useHistory();

    const [state, setState] = useState({
        teachersInSchool: { value: '', error: '', errorCode: '' },
        teacherList: [],
        bookingStatus: 0,
        bookingResponse: '',
        teacherRating: -1,
        teacherRatingAmount: '',
    });

    const [cancelling, setCancelling] = useState(false);
    const [snackState, setSnackState] = useState({
        message: '',
        open: false,
        severity: 'info',
    });

    const [schoolState, setSchoolState] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const schoolAddress = schoolInfo.school.Data.address;
        if (schoolAddress !== undefined)
            setSchoolState(schoolAddress.match(/\b([A-Z]{2,3})\b/)[1]);
    }, [schoolInfo]);

    useEffect(() => {
        console.log(
            'profileStatus',
            profileStatus,
            'schoolStatus',
            schoolStatus,
            'schoolInfo',
            schoolInfo
        );
        if (profileStatus === 'succeeded') {
            if (schoolStatus === 'idle') {
                async function dispatchSchoolFromStore() {
                    if (profile.profile.Data.Items.length > 0) {
                        const token = await getAccessTokenSilently({
                            scope: process.env.REACT_APP_scope,
                        });
                        const requestData = {
                            'token': token,
                            'schoolId': profile.profile.Data.Items[0]['gs1-pk'],
                        };
                        await dispatch(fetchSchool(requestData));
                    }
                }
                dispatchSchoolFromStore();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profileStatus, schoolStatus]);

    useEffect(() => {
        if (bookingStatus === 'succeeded') {
            var selected = booking.Data.filter(book => {
                return book.uniqueId === match.params.bookingId;
            });
            if (selected.length === 1) {
                setState({
                    ...state,
                    booking: selected[0],
                    bookingStatus: 2,
                    previousHistory: match.params.basePath,
                });
            }
        } else if (bookingStatus === 'failed') {
            setState({
                ...state,
                bookingStatus: 3,
                previousHistory: match.params.basePath,
            });
        } else if (bookingStatus === 'idle') {
            async function dispatchBookingFromStore() {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });
                dispatch(
                    fetchSchoolBooking({
                        token: token,
                    })
                );
            }
            // console.log('theme ' + JSON.stringify(classes));
            dispatchBookingFromStore();
            setState({
                ...state,
                bookingStatus: 1,
                previousHistory: match.params.basePath,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [booking, bookingStatus]);

    useEffect(() => {
        if (
            bookingStatus === 'succeeded' &&
            typeof state.booking !== 'undefined'
        ) {
            async function getRating() {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });
                axios
                    .get('/getTeachersRating', {
                        params: {
                            'ratingRequest': state.booking.pk1,
                            'getTeacherLicence': true,
                        },
                        baseURL: process.env.REACT_APP_API_GATEWAY,
                        url: `/getTeachersRating`,
                        timeout: 5000,
                        headers: {
                            authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    })
                    .then(result => {
                        console.log('status', JSON.stringify(result));
                        if (result.status === 200) {
                            setState({
                                ...state,
                                teacherRating: result.data.Message.Data.rating,
                                teacherRatingAmount:
                                    result.data.Message.Data.ratingsAmount,
                                teacherLicenceList:
                                    result.data.Message.Data.licenceList,
                            });
                        }
                    });
            }
            getRating();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookingStatus, state.booking]);

    async function cancelBookingReq() {
        setCancelling(true);
        // const bookingdispatch = await dispatch(
        //     cancelBooking({ pk1: state.booking.pk1, sk1: state.booking.sk1 })
        // );
        try {
            setSnackState({
                message: '',
                open: false,
                severity: 'info',
            });
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });

            let reqData = {
                token: token,
                request: {
                    pk1: state.booking.pk1,
                    sk1: state.booking.sk1,
                },
            };
            const response = await dispatch(cancelBooking(reqData));
            console.log('bookingDispatch', response);
            setCancelling(false);
            if (response.error !== undefined) {
                // setSnackState({
                //     message: 'Error cancelling booking',
                //     open: true,
                //     severity: 'error',
                // });

                sendNotification('error', 0, 'Error cancelling booking');
            } else {
                sendNotification('info', 6000, 'Booking Cancelled');
                // setSnackState({
                //     message: 'Booking Cancelled',
                //     open: true,
                //     severity: 'info',
                // });
            }
        } catch (err) {
            console.log('Err', err);
            sendNotification('error', 0, 'Error cancelling booking');
            // setSnackState({
            //     message: 'Error cancelling booking',
            //     open: true,
            //     severity: 'error',
            // });
        } finally {
            setCancelling(false);
        }
    }

    function goBack(event) {
        event.preventDefault();
        history.push('/history');
    }

    function goHome(event) {
        event.preventDefault();
        history.goBack();
    }

    let action;

    if (state.bookingStatus === 2) {
        if (
            profileStatus === 'succeeded' &&
            state.booking.status === 'Approved' &&
            compareAsc(parseISO(state.booking.startDate), Date.now()) === 1 &&
            typeof state.booking.uploadedDocuments === 'undefined'
        ) {
            action = (
                <SchoolApproved
                    sk1={state.booking.sk1}
                    uploadText={state.booking.schoolUploadText}
                    uploadDocument={state.booking.schoolUploadDocument}
                    id={state.booking.uniqueId}
                    user={`${profile.profile.Data.Items[0].firstName} ${profile.profile.Data.Items[0].lastName}`}
                />
            );
        } else if (
            state.booking.status === 'Approved' &&
            compareAsc(parseISO(state.booking.startDate), Date.now()) === 1 &&
            typeof state.booking.uploadedDocuments !== 'undefined'
        ) {
            if (
                !state.booking.uploadedDocuments.some(
                    document => document.thisUser === true
                )
            ) {
                action = (
                    <SchoolApproved
                        sk1={state.booking.sk1}
                        uploadText={state.booking.schoolUploadText}
                        uploadDocument={state.booking.schoolUploadDocument}
                        id={state.booking.uniqueId}
                    />
                );
            } else {
                action = (
                    <Typography variant="h5">Actions are completed</Typography>
                );
            }
        } else if (
            state.booking.status === 'Completed' ||
            state.booking.status === 'Pending Review'
        ) {
            action = (
                <SchoolRating
                    sk1={state.booking.sk1}
                    id={state.booking.uniqueId}
                    pk1={state.booking.pk1}
                    schoolName={state.booking.schoolName}
                    role={profile.profile.Data.Items[0].role}
                    status={state.booking.status}
                    pendingReview={
                        state.booking.status === 'Pending Review'
                            ? state.booking.pendingReview
                            : ''
                    }
                />
            );
        }
    } else {
        action = <Typography variant="h5">Actions are completed</Typography>;
    }

    let content;

    if (state.bookingStatus === 2) {
        if (typeof state.booking.uniqueId !== 'undefined') {
            content = (
                <div>
                    <BookingHeader
                        booking={state.booking}
                        userType="School"
                        teacherRatingAmount={state.teacherRatingAmount}
                        teacherRating={state.teacherRating}
                        licenceList={state.teacherLicenceList}
                        schoolState={schoolState}
                    />
                    <RootGrid container xs={12}>
                        <BookingSubDetails booking={state.booking} />
                        {state.booking.type !== 'quickBook' ? (
                            <Qualifications
                                skills={state.booking.skills}
                                otherSkills={state.booking.otherSkills}
                                grades={state.booking.grades}
                                gs1pk={state.booking.pk1}
                                schoolId={state.booking['gs1-pk']}
                            />
                        ) : (
                            <></>
                        )}

                        {state.booking.status === 'Processed' && (
                            <BookingRating
                                rating={state.booking.teacherRating}
                                comments={state.booking.teacherRatingComments}
                            />
                        )}
                    </RootGrid>
                </div>
            );
        } else {
            content = <NoBookingFound />;
        }
    } else if (state.bookingStatus === 1) {
        <Loading />;
    } else {
        content = <NoBookingFound />;
    }

    return (
        <Grid container directon="row" justifyContent="center">
            <Title title="Booking Summary" />
            <Grid
                item
                xs={12}
                md={8}
                directon="row"
                justifyContent="center"
                alignItems="center"
            >
                {state.booking !== undefined && (
                    <div>
                        {((state.booking.status === 'Approved' &&
                            compareAsc(
                                parseISO(state.booking.startDate),
                                Date.now()
                            ) === 1) ||
                            state.booking.status === 'Completed' ||
                            state.booking.status === 'Pending Review') && (
                            <Grid item xs={12}>
                                <Card
                                    sx={{
                                        margin: '20px',
                                        padding: '20px',
                                    }}
                                >
                                    {action}
                                </Card>
                            </Grid>
                        )}
                    </div>
                )}

                <TeacherCard>{content}</TeacherCard>
            </Grid>
            {state.bookingStatus === 2 &&
                typeof state.booking.uploadedDocuments !== 'undefined' && (
                    <Grid
                        item
                        xs={12}
                        md={8}
                        directon="row"
                        justifyContent="flex-start"
                        alignContent="stretch"
                    >
                        {state.booking.uploadedDocuments.map(document => (
                            <SchoolInfoProvided
                                title="Pre-booking Details"
                                subtitle="Information for the upcoming shift"
                                bookingDocExist={
                                    typeof document.document !== 'undefined'
                                }
                                text={document.text}
                                endDate={state.booking.endDate}
                                sk1={state.booking.sk1}
                                schoolUploadDocument={document.document}
                                schoolId={state.booking.gs1pk}
                                userType="School"
                                uploader={document.userName}
                            />
                        ))}
                    </Grid>
                )}
            {state.bookingStatus === 2 &&
                typeof state.booking.teacherFeedback !== 'undefined' && (
                    <Grid
                        item
                        xs={12}
                        md={8}
                        directon="row"
                        justifyContent="flex-start"
                        alignContent="stretch"
                    >
                        {typeof state.booking.teacherFeedback !==
                            'undefined' && (
                            <TeacherFeedback
                                report={state.booking.teacherFeedback}
                            />
                        )}
                    </Grid>
                )}
            {schoolStatus === 'succeeded' &&
                state.bookingStatus === 2 &&
                state.booking.type !== 'quickBook' && (
                    <Grid item xs={12} md={8}>
                        <Box sx={{ padding: '20px' }}>
                            <Documents
                                gs1pk={state.booking['pk1']}
                                schoolId={schoolInfo.school.Data.pk1}
                                loadOnInit={false}
                                filterResume={false}
                            />
                        </Box>
                    </Grid>
                )}
            <RootGrid container align="center">
                <Grid item xs={12}>
                    {state.booking !== undefined && (
                        <Box>
                            {(state.booking.status === 'Approved' ||
                                state.booking.status === 'Pending') && (
                                <BookingButton
                                    onClick={cancelBookingReq}
                                    variant="outlined"
                                    color="secondary"
                                    size="large"
                                    sx={{ margin: '0px 20px 20px 20px' }}
                                    loading={cancelling}
                                >
                                    Cancel Booking
                                </BookingButton>
                            )}

                            <BookingButton
                                onClick={goBack}
                                variant="outlined"
                                color="secondary"
                                size="large"
                                sx={{ margin: '0px 20px 20px 20px' }}
                            >
                                Back
                            </BookingButton>
                        </Box>
                    )}
                </Grid>
            </RootGrid>
            <SimpleSnackbar
                message={snackState.message}
                open={snackState.open}
                severity={snackState.severity}
            />
        </Grid>
    );
};

export default withAuthenticationRequired(ViewSchoolBooking, {
    onRedirecting: () => <Loading />,
});
